import { render, staticRenderFns } from "./ScreenCameraView.vue?vue&type=template&id=2eca440c&scoped=true"
import script from "./ScreenCameraView.vue?vue&type=script&lang=js"
export * from "./ScreenCameraView.vue?vue&type=script&lang=js"
import style0 from "./ScreenCameraView.vue?vue&type=style&index=0&id=2eca440c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2eca440c",
  null
  
)

export default component.exports